import { USER_ROLES, WEBBACK_V2_API } from "@constants"
import { useUserApp } from "@hooks"

const V2_PRICING = `${WEBBACK_V2_API}/pricing`

// **The url no longer depends on the role.** v1 has a twin nested for a retailer
// (`changes-retailers`) with duplicated logic; v2 has one endpoint and the back decides what the
// price is compared against from the user's role — the RRSP for a brand, their own main site for a
// retailer. Sending a role to a `-retailers` url on v2 would 404: it does not exist there.
//
// Reasoning: dipi-webback-v2/plans/869e5pfw2--rrsp-and-retailers.md §5.1 (one module, one API), and
// §8.2 of `--data-pricing-changes.md` for what the retailer regression does and does not prove. The
// role is still returned below, because the *columns* do vary: the table relabels the price column
// and switches the Excel between `RRSP` and `My Price`.
//
// The MARKETPLACES branch of `urlApiPriceEvolution` is gone rather than ported: that role is out of
// scope for the migration and is not coming back. It was already unreachable here — `urlApi` never
// mapped it, so a marketplaces user would have requested a literal `undefined` path.

export default function usePricingChangesRoleConfig() {
	const { userRole, userUseRRSP } = useUserApp()

	return {
		userRole,
		urlApi: `${V2_PRICING}/changes/context`,
		urlApiExcel: `${V2_PRICING}/changes/excel`,
		urlApiPriceEvolution: `${V2_PRICING}/changes/price-stock-evolution`,
		isRetailerUser: userRole === USER_ROLES.RETAILER,
		isStandardUser: userRole === USER_ROLES.STANDARD,
		userUseRRSP: userUseRRSP
	}
}
